import loadProductGroupFredhopperModule from './modules/ProductGroupFredhopper.module';
import loadWishListModule from './modules/WishList.module';
import loadCompareModule from './modules/Compare.module';
import loadProductModule from './modules/Product.module';
const loadProductGroupPdpComparisonFredhopperRootModule = (initialData) => {
    return {
        hasRouter: false,
        modules: [
            loadProductGroupFredhopperModule(initialData),
            loadCompareModule(),
            loadWishListModule(),
            loadProductModule(),
        ],
    };
};
export default loadProductGroupPdpComparisonFredhopperRootModule;
